

const Modal = ({ isOpen, onClose, title, children, maxWidth = "max-w-3xl" }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 transition-opacity">

            <div
                className={`bg-white rounded-xl shadow-2xl w-full ${maxWidth} transform transition-all scale-100 flex flex-col max-h-[90vh]`}
                onClick={(e) => e.stopPropagation()}
            >

                {/* Header (Stays Fixed at Top) */}
                <div className="flex justify-between items-center p-6 border-b border-gray-100">
                    <h2 className="text-xl font-bold text-gray-800">{title}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-red-500 text-2xl">&times;</button>
                </div>

                <div className="p-6 overflow-y-auto">
                    {children}
                </div>

            </div>
        </div>
    );
};

export default Modal;